
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../src/_metronic/assets/sass/override.css'

export const URL =
{
    uatgogagnerurl: process.env.REACT_APP_API_URL
}

const API_LANGS = ['en', 'ru', 'uz'];

// Language currently selected in the app (same storage as Metronici18n, read directly
// to avoid a circular import since Metronici18n imports fetchData)
export const getApiLanguage = (): string => {
    try {
        const ls = localStorage.getItem(process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig');
        const lang = ls ? JSON.parse(ls)?.selectedLang : '';
        if (API_LANGS.includes(lang)) return lang;
    } catch (er) {
        console.error(er);
    }
    return 'uz';
}

// Add `language` to a JSON payload unless the caller already passed one
const withLanguage = (raw: any) => {
    if (raw instanceof FormData) {
        if (!raw.has('language')) raw.append('language', getApiLanguage());
        return raw;
    }
    if (raw === undefined || raw === null) return { language: getApiLanguage() };
    if (typeof raw === 'object' && !Array.isArray(raw)) return { language: getApiLanguage(), ...raw };
    return raw;
}

// Add `language` as a query param to GET urls unless already present
const withLanguageQuery = (url: string) => {
    if (/[?&]language=/.test(url)) return url;
    return `${url}${url.includes('?') ? '&' : '?'}language=${getApiLanguage()}`;
}

export const fetchFormData = async (url: string, raw: any) => {

    var myHeaders = new Headers();
    myHeaders.append("apitoken", process.env.REACT_APP_API_TOKEN || '');

    var requestOptions: any =
    {
        method: 'POST',
        headers: myHeaders,
        body: withLanguage(raw),
        redirect: 'follow'
    };

    let response = await fetch(URL.uatgogagnerurl + url, requestOptions);
    let json = await response.json();

    return json;
}

export const fetchData = async (url: string, raw: any) => {

    var myHeaders: any = new Headers();
    myHeaders.append("apitoken", process.env.REACT_APP_API_TOKEN || '');
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");

    var requestOptions =
    {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(withLanguage(raw))
    };

    let response = await fetch(URL.uatgogagnerurl + url, requestOptions);
    let json = await response.json();
    return json;
}

// Normalizes a server-side paginated list response into { list, total }.
// Supports `data: [...]` as well as `data: { data | list: [...], totalRecords | totalRecord | total | count }`.
export const parsePaginatedList = (res: any) => {
    const payload = res?.data
    const list = Array.isArray(payload) ? payload : (payload?.data ?? payload?.list ?? payload?.rows ?? [])
    const total = Number(
        payload?.totalRecords ?? payload?.totalRecord ?? payload?.total ?? payload?.count ??
        res?.totalRecords ?? res?.totalRecord ?? res?.total ?? res?.count ??
        (Array.isArray(list) ? list.length : 0)
    ) || 0
    return { list: Array.isArray(list) ? list : [], total }
}

export const fetchGetData = async (url: string) => {

    var myHeaders: any = new Headers();
    myHeaders.append("apitoken", process.env.REACT_APP_API_TOKEN || '');
    myHeaders.append("Accept", "application/json");

    var requestOptions =
    {
        method: 'GET',
        headers: myHeaders,
    };

    let response = await fetch(URL.uatgogagnerurl + withLanguageQuery(url), requestOptions);
    let json = await response.json();
    return json;
}

export const deleteData = async (url: string, raw: any) => {

    var myHeaders: any = new Headers();
    myHeaders.append("apitoken", process.env.REACT_APP_API_TOKEN || '');
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");

    var requestOptions =
    {
        method: 'DELETE',
        headers: myHeaders,
        body: JSON.stringify(withLanguage(raw))
    };

    let response = await fetch(URL.uatgogagnerurl + url, requestOptions);
    let json = await response.json();
    return json;
}

export function toasterrormsg(message: any) {
    toast.error(message, {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
    });
}

export function toastsuccessmsg(message: any) {
    toast.success(message, {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
        // className:'Toastify__progress-bar--animated'
    });
}


export const dateFormat = (date: any) => {
    const inputDate = new Date(date);

    if (date != undefined && date != null && date == '') {
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1) > 9 ? (inputDate.getMonth() + 1) : '0' + (inputDate.getMonth() + 1);
        const day = inputDate.getDate() > 9 ? inputDate.getDate() : '0' + inputDate.getDate();
        return `${year}-${month}-${day}`;
    }
    else {
        return ''
    }

}
export const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number)
    const period = hours >= 12 ? 'PM' : 'AM'
    const adjustedHours = hours % 12 || 12
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes // Ensure minutes are two digits
    return `${adjustedHours}:${formattedMinutes} ${period}`
}
export function formatDate(dateString: any) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript

    return `${year}-${day}-${month}`;
}
export const getNumberOfDays = (fromDate: any, toDate: any) => {
    const start = moment(fromDate);
    const end = moment(toDate);
    // Calculate the difference in days
    const duration = end.diff(start, 'days');
    return duration;
}
export const getNumberOfHoursFromDateTime = (fromTime: any, toTime: any) => {
    const start = moment(fromTime, 'YYYY-MM-DD HH:mm:ss');
    const end = moment(toTime, 'YYYY-MM-DD HH:mm:ss');

    // Calculate the difference in hours
    const duration = end.diff(start, 'hours', true);

    return duration;
}
export const getNumberOfHoursTime = (fromTime: any, toTime: any) => {
    const start = moment(fromTime, 'HH:mm:ss');
    const end = moment(toTime, 'HH:mm:ss');

    // Calculate the difference in hours
    const duration = end.diff(start, 'hours', true);

    return duration;
}
export const isOnlyNumber = (value: any) => {
    // Regular expression to match any non-numeric character
    const regex = /[^0-9]/;
    // Check if the value contains any non-numeric characters
    if (regex.test(value)) {
        // Value contains non-numeric characters, return false
        return false;
    }
    // Value contains only numbers
    return true;
};
export const isOnlyAlphabetic = (value: any) => {
    // Regular expression to match only alphabetic characters and space
    const regex = /^[a-zA-Z\s]+$/;
    // Check if the value contains only alphabetic characters and space
    return regex.test(value);
};
export const hasSpecialCharacters = (value: any) => {
    // Regular expression to match special characters excluding spaces and English, Russian, and Uzbek language characters
    const specialCharacterRegex = /[^\w\u0020\u002C\u0430-\u044F\u0410-\u042F\u0401\u0451\u0493\u049B\u04E9\u04EF\u0513\u051B\u0523\u052B\u0533\u053B]/;
    // Test if the value contains any special characters
    return !specialCharacterRegex.test(value);
};
export const isSpecificSpecialCharacters = (value: any) => {
    const regex = /^[a-zA-Z<>,."'*() -]*$/; // Regular expression to allow alphabetical characters and specific special characters
    return regex.test(value);
}
export const limitLength = (value: any, maxLength: any) => {
    if (value.length <= maxLength) {
        return value; // If the value is within the limit, return it unchanged
    } else {
        return value.slice(0, maxLength) + '...'; // Otherwise, return a portion of the value with ellipsis
    }
}
export const formatNumber = (number: any) => {
    const [integerPart, decimalPart] = number.toString().split(".");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPart ? `${formattedInteger}.${decimalPart.slice(0, 2)}` : formattedInteger;
};
export const handleTimeChange = (date: any, roundingInterval = 15) => {
    if (date && date.length > 0) {
        const selectedTime = moment(date[0]); // Get the first element if date is an array
        if (selectedTime.isValid()) {
            const roundedTime = selectedTime.minute(Math.round(selectedTime.minute() / roundingInterval) * roundingInterval).second(0);
            return roundedTime.format('HH:mm'); // Return the rounded time
        } else {
            console.error("Invalid date selected");
        }
    }
    return '00:00'; // Return null if no valid date is selected
};
const uploadImage = async (file: any) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('language', getApiLanguage());

    try {
        const response = await axios.post(`${URL.uatgogagnerurl}public/descrptionImageUpload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response.data.success) {
            return response.data.fileUrl; // Adjust this based on your server response
        } else {
            console.error('Upload error:', response.data.message);
            return null;
        }
    } catch (error) {
        console.error('Upload error:', error);
        return null;
    }
};

export const config: any = {
    uploader: {
        insertImageAsBase64URI: false,
    },
    buttons: [
        'source', '|',
        'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', '|',
        'ul', 'ol', 'outdent', 'indent', '|',
        'font', 'fontsize', 'brush', 'paragraph', '|',
        {
            name: 'image',
            exec: async function (editor: any) {
                const input = document.createElement('input') as any;
                input.type = 'file';
                input.accept = 'image/*';
                input.onchange = async function () {
                    const file = input.files[0];
                    if (file) {
                        const imageUrl = await uploadImage(file);
                        if (imageUrl) {
                            editor.selection.insertImage(imageUrl);
                        }
                    }
                };
                input.click();
            }
        }, 'table', 'link', '|',
        'align', 'undo', 'redo', '|',
        'hr', 'eraser', 'copyformat', '|',
        'symbol', 'fullsize', 'print', 'about',
    ],
    toolbarAdaptive: false,
    toolbarSticky: false,
    toolbarButtonSize: 'middle',
    showCharsCounter: true,
    // whitespace isn't counted (the Jodit bundled with jodit-react 4.1.2 never counts it anyway)
    countTextSpaces: false,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: 'insert_clear_html',
    placeholder: '',
};

// Visible text length of editor HTML without whitespace: strips tags, decodes entities
// (&nbsp;, &amp;, ...) and counts the same way as Jodit's CHARS counter
export const getPlainTextLength = (html: string): number => {
    const text = new DOMParser().parseFromString(html || '', 'text/html').body.textContent || '';
    return text.replace(/[\s\uFEFF\u200b]+/g, '').length;
};

// name fields differ per module: hotels/restaurants use *_name, hotel rooms *_roomName,
// tour packages *_agencyName, car rentals *_supplierName
const NAME_SUFFIXES = ['_name', '_roomName', '_agencyName', '_supplierName'];
const LANGS = ['en', 'ru', 'uz'];

// Suffix of the first translated name field the item actually carries a value for
export const findNameSuffix = (item: any): string => {
    const known = NAME_SUFFIXES.find((suffix) => LANGS.some((l) => item?.[`${l}${suffix}`]));
    if (known) return known;
    const anyKey = Object.keys(item || {}).find(
        (k) => LANGS.some((l) => k.startsWith(`${l}_`)) && typeof item[k] === 'string' && item[k]
    );
    return anyKey ? anyKey.slice(anyKey.indexOf('_')) : '';
};

// Display name of a listing in the selected language: prefer <lang>_<field>, then the
// record's primaryLanguage, then any language that has a value
export const getLocalizedName = (item: any, lang: any, suffix?: string): string => {
    const nameSuffix = suffix || findNameSuffix(item);
    if (!nameSuffix) return '';
    const translated = getTranslatedValue(lang, item, nameSuffix);
    if (translated) return translated;
    return LANGS.map((l) => item?.[`${l}${nameSuffix}`]).find((v) => v) || '';
};

// Helper function to get value: prefer lang-specific, fallback to primary
export const getTranslatedValue = (lang: any, propertyType: any, suffix: any, overridePrimaryLang?: any) => {
    const primaryToCode: any = {
        "English": "en",
        "Russian": "ru",
        "Uzbek": "uz"
    };
    const preferredKey = `${lang}${suffix}`;
    if (propertyType[preferredKey]) return propertyType[preferredKey];

    // Only fallback if primaryLanguage exists and is valid
    const primaryLang = overridePrimaryLang ?? propertyType.primaryLanguage ?? '';
    if (primaryLang && primaryToCode[primaryLang]) {
        const primaryCode = primaryToCode[primaryLang];
        const fallbackKey = `${primaryCode}${suffix}`;
        return propertyType[fallbackKey] || "";
    }
    // Directly return empty if no valid primaryLanguage
    return "";
};
